
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact/redesign_labo/form",
      function () {
        return require("private-next-pages/contact/redesign_labo/form.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact/redesign_labo/form"])
      });
    }
  